/**
 * @description
 *
 * Диспатчит событие и доп данные на window
 *
 * @param {string} name - название события
 * @param {any} detail - данные, передаваемые с событием
 *
 * @returns {any} -
 */

function dispatchCustomEventGlobally(name, detail = '') {
  if (!name || typeof name !== 'string') {
    return
  }

  window.dispatchEvent(new CustomEvent(name, { detail }))
}

export default dispatchCustomEventGlobally
